import { render, staticRenderFns } from "./shift.vue?vue&type=template&id=4fb65878&scoped=true&"
import script from "./shift.vue?vue&type=script&lang=js&"
export * from "./shift.vue?vue&type=script&lang=js&"
import style0 from "./shift.vue?vue&type=style&index=0&id=4fb65878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb65878",
  null
  
)

export default component.exports